var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowDown1 = function SvgArrowDown1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7149 3.0814L11.1374 2.50366C10.9372 2.31374 10.7035 2.21875 10.4366 2.21875C10.1643 2.21875 9.93333 2.31374 9.74333 2.50366L6.00001 6.24708L2.25673 2.50376C2.06676 2.31384 1.83572 2.21886 1.56349 2.21886C1.29653 2.21886 1.06282 2.31384 0.862652 2.50376L0.292676 3.08151C0.0975228 3.27653 0 3.51023 0 3.78241C0 4.05965 0.0976307 4.29071 0.292649 4.47553L5.30675 9.48966C5.49168 9.68471 5.72263 9.78231 5.99999 9.78231C6.27213 9.78231 6.50581 9.68474 6.70078 9.48966L11.7149 4.47553C11.9049 4.28551 12 4.05447 12 3.78241C12 3.5153 11.9049 3.28174 11.7149 3.0814Z",
    fill: "#124B88"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDown1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down(1).555e6d38.svg";
export { ForwardRef as ReactComponent };